// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3h1au","info":"Note_info__1L1PI","note":"Note_note__2_vK3","actions":"Note_actions__1ZEuE"};